import client from '../clients/base';
import {createFormData} from '../../utils/createFormData';

const UPDATE_USER_URL = 'update-user/';
const UPDATE_ORG_URL = 'update-organisation/';
const CREATE_ORG_URL = 'create-organisation/';

const updateUser = async (data: any) => {
  try {
    const res = await client.post(UPDATE_USER_URL, createFormData(data));
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const updateOrganisation = async (data: any) => {
  try {
    const res = await client.post(UPDATE_ORG_URL, createFormData(data));
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const createOrganisation = async (data: any) => {
  try {
    const res = await client.post(CREATE_ORG_URL, createFormData(data));
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const actions = {
  updateUser,
  updateOrganisation,
  createOrganisation,
};

export default actions;
